module.exports = __webpack_public_path__ + "img/partner2.5bd0e482.jpg";